import {cleanPpu, Ppu} from './ppu';

export * from './ppu';

export const formatPatent = (ppu) => {
    return new Ppu(cleanPpu(ppu)).formatted;
}
